<template>
  <div style="z-index: 999;">
    <el-dialog
      title="添加达人"
      width="900px"
      :visible="value"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      top="40px"
      append-to-body
      class="partial"
      @close="onCancel"
      custom-class="import-dialog"
    >
      <div class="">
        <el-form :model="searchForm" class="search-form" ref="searchFormRef">
          <el-form-item label="" prop="code">
            <el-input
              style="width: 700px"
              v-model="searchForm.code"
              placeholder="输入抖音号，多个请用“,”隔开，如：2455afaaf,jljl9999,87888df"
            />
          </el-form-item>
          <el-form-item label="">
            <el-button type="warning" @click="handleAdd">添加</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="container">
        <div class="container-header">
          <div class="left">
            <div class="b">已添加达人</div>
            <div @click="handleBatchSet" class="s cur">批量设置佣金</div>
          </div>
          <div>已选 {{form.items.length}}/1000</div>
        </div>
        <div class="add" @click="handleSelectAll">全选</div>
        <div class="list">
          <el-form :model="form" ref="form">
            <div v-for="(item,index) in form.items" :key="index" class="item-box">
              <div class="box">
                <el-checkbox :disabled="item.disabled" style="margin-right: 10px;margin-top: 10px;" v-model="item.checked">抖音号：{{item.douyinId}}</el-checkbox>
                <div class="box-text">
                </div>
              </div>
              <div>
                <el-form-item :error="item.error" label="佣金设置" label-width="100px">
                  <el-input
                    v-model="item.commissionRate"
                    style="width: 200px;"
                    placeholder="1~29"
                    @input="handleInput($event, index)"
                    :disabled="item.disabled"
                  >
                    <template slot="append">%</template>
                  </el-input>
                </el-form-item>
              </div>
              <div class="delete">
                <i v-if="!item.disabled" @click="handleDelete(index)" class="el-icon-close cur"></i>
              </div>
            </div>
          </el-form>
        </div>
      </div>
      <div class="btns-coantainer">
        <el-button type="warning" plain @click="onCancel">取消</el-button>
        <el-button type="warning" @click="submit"
        >确认添加</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      title="佣金设置"
      width="30%"
      :visible="commissionVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @close="closeCommission"
    >
      <div>
        佣金设置
        <el-input
          v-model="commissionAll"
          style="width: 200px;"
          placeholder="1~29"
        >
          <template slot="append">%</template>
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
    <el-button @click="commissionVisible = false">取 消</el-button>
    <el-button type="primary" @click="commissionSubmit">确 定</el-button>
  </span>
    </el-dialog>
  </div>
</template>

<script>
import {matchIntegerNew,matchNegativePart3} from "@/utils/regExp.js";
export default {
  name: "addExpertPop",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    oldDarens: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      commissionVisible: false,
      commissionAll:'',
      searchForm: {
        code: '',
      },
      form:{
        items: [],
      },
      select:[],
    };
  },
  watch:{
    "form.items": {
      handler(newVal) {
        console.log(newVal, 'newVal');
        if(newVal.length) {
          this.select = newVal.filter(item => item.checked)
        }else{
          this.select = [];
        }
        // 这里可以添加对 items 数组变化的处理逻辑
      },
      deep: true,
    },
    "value":{
      handler(newVal) {
        console.log(newVal, 'value=========12');
        if(newVal) {
          this.form.items = this.oldDarens.map(item => {
            return {
              ...item,
              error: '',
              checked: false,
            }
          })
          this.select = [];
        }
      },
      immediate: true,
    },
  },
  methods:{
    handleSelectAll() {
      if(this.form.items.length === 0) {
        this.$message.error('请添加达人');
        return;
      }
      if(this.select.length === this.form.items.length) {
        this.form.items.forEach(item => {
          item.checked = false;
        });
        return;
      }
      this.form.items.forEach(item => {
        if(!item.disabled) {
          item.checked = true;
        }
      });
      // this.select = this.form.items.filter(item => item.checked);
    },
    closeCommission() {
      this.commissionVisible = false
    },
    commissionSubmit() {
      if(!matchNegativePart3.test(this.commissionAll) || (Number(this.commissionAll) < 1 || Number(this.commissionAll) > 29)) {
        this.$message.error('请输入1~29，最多1位小数')
        return
      }
      this.closeCommission()
      this.form.items.forEach(item => {
        if(item.checked) {
          item.commissionRate = this.commissionAll
          item.error = ''
          item.checked = false
        }
      });
    },
    async validate() {
      let errorMessage = ''
      this.form.items.forEach(item => {
        if(!matchNegativePart3.test(item.commissionRate) || (Number(item.commissionRate) < 1 || Number(item.commissionRate) > 29)) {
          item.error = '请输入1~29，最多1位小数';
          errorMessage = '请输入1~29，最多1位小数'
          return;
        }
      });
      if(errorMessage) {
        this.$message.error(errorMessage)
        return Promise.reject(errorMessage);
      }
      return Promise.resolve();
    },
    async submit() {
      if(this.form.items.length === 0) {
        this.$message.error('请添加达人');
        return;
      }
      await this.validate()
      this.$emit('expertSubmit', this.form.items);
      // this.$emit("close", false);
    },
    handleBatchSet() {
      if(this.select.length === 0) {
        this.$message.error('请至少选择一个达人');
        return;
      }
      this.commissionAll = ''
      this.commissionVisible = true
    },
    handleInput(e,index) {
      console.log(e, index, 'e,index',typeof e,Number(e) < 1 || Number(e) > 29,!matchNegativePart3.test(e))
      if(!matchNegativePart3.test(e) || (Number(e) < 1 || Number(e) > 29)) {
        this.form.items[index].error = '请输入1~29，最多1位小数';
        console.log('error222')
      } else {
        console.log('error333')
        this.form.items[index].error = '';
      }
    },
    handleDelete(index) {
      console.log(index, 'index');
      this.form.items[index].checked = false
      this.form.items.splice(index, 1);
    },
    handleAdd() {
      if(this.searchForm.code === '') {
        this.$message.error('请输入抖音号');
        return;
      }
      if(this.searchForm.code.includes('，')) {
        this.$message.error('请使用英文逗号“,”隔开抖音号');
        return;
      }
      const codes = this.searchForm.code.split(',');
      console.log(codes, 'codes');
      if(this.form.items.length + codes.length > 1000) {
        this.$message.error('最多添加1000个达人');
        return;
      }
      if(codes.length) {
        let list = codes.filter(item => {
          return item.trim() !== '';
        })
        if(!list.length) {
          this.$message.error('请输入正确的抖音号');
          return;
        }
        // let oldRepeat = []
        // if(this.oldDarens.length) {
        //   this.oldDarens.forEach(item => {
        //     if(list.includes(item)) {
        //       oldRepeat.push(item)
        //     }
        //   })
        // }
        // console.log(oldRepeat,'oldRepeatoldRepeat',list)
        // if(oldRepeat.length) {
        //   this.$message.error(`抖音号 ${oldRepeat} 已存在`);
        //   return;
        // }
        // console.log(this.oldDarens,'oldDarensoldDarens')
        // 重复
        let repeat = []
        let repeatList = this.form.items.filter(item => {
          return list.includes(item.douyinId)
        })
        console.log(repeatList,'repeatListrepeatList',repeat)
        if(repeatList.length) {
          repeatList.forEach(item => {
            repeat.push(item.douyinId)
          })
          this.$message.error(`抖音号 ${repeat} 已存在`);
        }
        list.forEach(item => {
          if(!this.form.items.some(i => i.douyinId === item.trim())) {
            this.form.items.unshift({
              douyinId: item.trim(),
              commissionRate: '',
              error: '',
              checked: false,
            });
          } else {

          }
        });
        this.searchForm.code = ''
      }

      // this.form.items.push({
      //   url: 'https://p0.pipi.cn/mediaplus/friday_image_fe/0fa3343d6e34eaf87bb24e0b8465a29a48293.jpg?imageMogr2/thumbnail/1246x1246%3E_300x300.jpg',
      //   name: '新达人',
      //   douyinId: '12311',
      //   commissionRate: '',
      //   error: '',
      //   checked: false,
      // });
    },
    // 取消
    onCancel() {
      this.$emit("close", false);
    },
  },
}
</script>

<style scoped lang="less">
// 弹出层的高度
/deep/.el-dialog.import-dialog {
  max-height: calc(100vh - 100px) !important;
  // max-height: 800px;
  overflow-y: auto;
  background: #fff;
  z-index: 999;
  // margin: auto !important;
}
.container{
  width: 800px;
  margin-bottom: 10px;
  border-top: 1px solid #999;
  padding-top: 10px;
}
.list{
  display: flex;
  width: 820px;
  justify-content: space-between;
  min-height: 300px;
  overflow-y: auto;
  height: calc(100vh - 440px);
}
.item-box{
  width: 800px;
  display: flex;
  background: #f9fafb;
  padding: 20px 20px 0 20px;
  position: relative;
  margin-bottom: 10px;
  border-radius: 8px;
}
.box{
  width: 200px;
  display: flex;
  .box-img{
    width: 50px;
    height: 50px;
    margin-right: 10px;
  }
  .box-text{
    .name{
      font-weight: bold;
      color: #333;
    }
    .douyinId{
      font-size: 12px;
      color: #666;
    }
  }
}
.delete{
  width: 50px;
  display: flex;
  justify-content: center;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}
.container-header{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  .left{
    display: flex;
    align-items: center;
    .b{
      font-weight: 700;
      color: #333;
    }
    .s{
      font-size: 12px;
      margin-left: 10px;
    }
  }
}
.btns-coantainer{
  z-index: 99;
  //width: 100%;
  padding: 10px;
  display: flow;
  float: right;
}
.cur{
  cursor: pointer;
}
.add{
  color: #409EFF;
  cursor: pointer;
  margin-left: 20px;
  //text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/miniProgram/poiCps/components/addExpertPop.vue